import { CommonModule } from '@angular/common';
import { PopOverComponent } from './pop-over.component';
import { PopOverTrigger } from './pop-over-trigger.directive';
import { NgModule } from '@angular/core';
export var PopoverModule = (function () {
    function PopoverModule() {
    }
    PopoverModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        PopOverComponent,
                        PopOverTrigger
                    ],
                    exports: [
                        PopOverComponent,
                        PopOverTrigger
                    ],
                    entryComponents: [
                        PopOverComponent
                    ]
                },] },
    ];
    /** @nocollapse */
    PopoverModule.ctorParameters = function () { return []; };
    return PopoverModule;
}());
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-pop-over/index.js
// module id = 490
// module chunks = 4